import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../../../Icon/Icon';
export const Checkmark = () => {
    return (_jsx("div", { className: 'checkbox-component-checkmark', children: _jsx("div", { className: 'checkbox-component-icon', children: _jsx(Icon, { name: 'check', color: 'white', size: 'sm' }) }) }));
};
